import { typeMap as errorTypeMap } from './type-map';
import { GeneralError } from './base';

export class ConversionSmilesToMolError extends GeneralError {
  constructor(payload) {
    super(errorTypeMap.conversion.smilesToMol, payload);
  }
}

export class ConversionMolToSmilesError extends GeneralError {
  constructor(payload) {
    super(errorTypeMap.conversion.molToSmiles, payload);
  }
}

export class ConversionMolfileToMolError extends GeneralError {
  constructor(payload) {
    super(errorTypeMap.conversion.molfileToMol, payload);
  }
}

export class ConversionReactionToRxnError extends GeneralError {
  constructor(payload) {
    super(errorTypeMap.conversion.reactionToRxn, payload);
  }
}
